module.exports = __webpack_public_path__ + "static/media/layout.50a0ec11.png";